import React from "react";
import classes from "./SortingList.module.scss";
import SortingCard from "./card/SortingCard";
import {
  DndContext,
  KeyboardSensor,
  MouseSensor,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  rectSortingStrategy,
  SortableContext,
  sortableKeyboardCoordinates,
} from "@dnd-kit/sortable";
import { SortableItem } from "./card/SortableItem";

const SortingList = (props) => {
  const { sortedProducts, categoryList, setSortedProducts, categoryId } = props;

  // フィルタされた商品のみを表示用に取得
  const filteredProducts =
    categoryId === "all"
      ? sortedProducts
      : sortedProducts.filter((product) => product.category === categoryId);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 2 } }),
    useSensor(TouchSensor, { activationConstraint: { distance: 2 } }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
    useSensor(MouseSensor, { activationConstraint: { distance: 2 } })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      // フィルタされた商品の中での並び替え位置を取得
      const filteredOldIndex = filteredProducts.findIndex(
        (product) => product.id === active.id
      );
      const filteredNewIndex = filteredProducts.findIndex(
        (product) => product.id === over.id
      );

      // 全体のリストでの位置を取得
      const fullOldIndex = sortedProducts.findIndex(
        (product) => product.id === active.id
      );
      const fullNewIndex = sortedProducts.findIndex(
        (product) => product.id === over.id
      );

      // 移動方向を判定（上か下か）
      const isMovingDown = filteredOldIndex < filteredNewIndex;

      // 全体のリストを複製
      const newSortedProducts = [...sortedProducts];

      // 移動するアイテムを取り出す
      const [movedItem] = newSortedProducts.splice(fullOldIndex, 1);

      // 新しい位置に挿入
      // 下に移動する場合は、移動先の次の位置に挿入
      if (isMovingDown) {
        const nextIndex = fullNewIndex;
        newSortedProducts.splice(nextIndex, 0, movedItem);
      }
      // 上に移動する場合は、移動先の位置に直接挿入
      else {
        newSortedProducts.splice(fullNewIndex, 0, movedItem);
      }

      // orderNo を再計算
      const updatedProducts = newSortedProducts.map((product, index) => ({
        ...product,
        orderNo: index + 1,
      }));

      setSortedProducts(updatedProducts);
    }
  };

  return (
    <DndContext sensors={sensors} onDragEnd={handleDragEnd}>
      <div className={classes.container}>
        <div className={classes.list}>
          <SortableContext
            items={filteredProducts.map((product) => product.id)}
            strategy={rectSortingStrategy}
          >
            {filteredProducts.map((product) => {
              const category = categoryList.find(
                (cat) => cat.id === product.category
              );
              const color = category ? category.color : "#FFFFFF";
              const categoryName = category ? category.name : "未分類";
              return (
                <SortableItem key={product.id} id={product.id}>
                  <SortingCard
                    product={product}
                    color={color}
                    categoryName={categoryName}
                  />
                </SortableItem>
              );
            })}
          </SortableContext>
        </div>
      </div>
    </DndContext>
  );
};

export default SortingList;
